import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { verifyEmail } from "../../../utilities/API/supertokenServices"
import { toast } from "react-toastify"

export const verifyEmailService = createAsyncThunk(
    'fetchPreAuthFAF', verifyEmail
)

const initialState = {
    loader: false
}

const verifyEmailSlice = createSlice({
    name: 'preAuth',
    initialState,
    reducers: {
        resetVerifyEmail: (state) => {
            state.loader = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(verifyEmailService.pending, (state, action) => {
                state.loader = true
            })
            .addCase(verifyEmailService.fulfilled, (state, action) => {
                state.loader = false
            })
            .addCase(verifyEmailService.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader = false
            })
    }
})

export const { resetVerifyEmail } = verifyEmailSlice.actions

export default verifyEmailSlice.reducer